const SAR_PROJECTS = new Set([
  'visa',
  'visaguthaben',
  'visateilzahlung',
  'amexv2',
]);

export const isSarProject = (project: string | undefined): boolean =>
  project !== undefined && SAR_PROJECTS.has(project);

export const isSarAutoLoginRoute = (
  pathname: string,
  search: string
): boolean => {
  const normalizedPath = pathname.replace(/\/+$/, '');
  const project = normalizedPath.split('/')[1];
  return (
    isSarProject(project) &&
    normalizedPath === `/${project}/login` &&
    new URLSearchParams(search).has('sarcode')
  );
};
